import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5211340e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "shadow-lg grid grid-cols-1 2xl:grid-cols-2 w-4/5 sm:w-full items-center",
  style: {"border-radius":"6px"}
}
const _hoisted_2 = { class: "p-7 flex justify-center 2xl:flex-none" }
const _hoisted_3 = { class: "img-div" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { style: {"position":"absolute","left":"-10px","top":"10px"} }
const _hoisted_6 = {
  key: 0,
  class: "label new"
}
const _hoisted_7 = {
  key: 1,
  class: "label sale"
}
const _hoisted_8 = { class: "text-center p-7 grid content-between h-full" }
const _hoisted_9 = {
  class: "mt-2",
  style: {"color":"#707070"}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = {
  key: 0,
  style: {"color":"#707070"}
}
const _hoisted_13 = {
  class: "mt-4 relative flex justify-center",
  style: {"height":"40px"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons-round align-middle text-lg leading-none" }, "check", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_more_info_button = _resolveComponent("more-info-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.itemData.thumbnail,
          style: {"position":"absolute","top":"0","right":"0","left":"0","bottom":"0","width":"100%","height":"100%","object-fit":"contain"}
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.itemData.attributes['newitem'])
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("Novo")), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.itemData.discount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("Akcija")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.itemData.title), 1),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.itemData.discount)
            ? (_openBlock(), _createElementBlock("del", _hoisted_10, _toDisplayString(_ctx.itemData.priceWithoutDiscount), 1))
            : _createCommentVNode("", true),
          _createTextVNode(_toDisplayString(_ctx.itemData.price), 1)
        ]),
        _createVNode(_component_more_info_button, {
          title: _ctx.$t('Več info'),
          item: _ctx.itemData,
          style: {"width":"fit-content","margin":"auto"}
        }, null, 8, ["title", "item"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.impregnation || _ctx.grout)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t("Št.kosov")) + ": " + _toDisplayString(_ctx.itemData.quantity || 0), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_a_form, {
          ref: "formRef",
          model: _ctx.itemData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              name: "quantity",
              rules: {
                     required: true,
                     validator: _ctx.validateArea
                   }
            }, {
              default: _withCtx(() => [
                (_ctx.impregnation || _ctx.grout)
                  ? (_openBlock(), _createBlock(_component_a_input, {
                      key: 0,
                      ref: "quantity",
                      value: _ctx.inputValue,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
                      onChange: _ctx.buttonChange,
                      class: "hideStepper",
                      style: {"height":"40px","border-radius":"6px","max-width":"200px"},
                      type: "number",
                      min: "1",
                      placeholder: _ctx.$t('Vpiši kvadraturo'),
                      suffix: "m2"
                    }, null, 8, ["value", "onChange", "placeholder"]))
                  : (_openBlock(), _createBlock(_component_a_input, {
                      key: 1,
                      ref: "quantity",
                      value: _ctx.itemData.quantity,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemData.quantity) = $event)),
                      onChange: _ctx.buttonChange,
                      onBlur: _ctx.buttonBlur,
                      class: "hideStepper",
                      style: {"height":"40px","border-radius":"6px","max-width":"200px"},
                      type: "number",
                      min: "1",
                      onkeypress: "return event.charCode >= 48 && event.charCode <= 57",
                      placeholder: _ctx.itemData.priceUnit === 'm2' ? _ctx.$t('Vpiši kvadraturo') : _ctx.$t('Vpiši količino'),
                      suffix: _ctx.itemData.priceUnit || ' '
                    }, null, 8, ["value", "onChange", "onBlur", "placeholder", "suffix"]))
              ]),
              _: 1
            }, 8, ["rules"])
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              (_ctx.itemAdded==true)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "w-full app-button-addon-selected absolute",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addItem(false)))
                  }, [
                    _hoisted_14,
                    _createTextVNode("  " + _toDisplayString(_ctx.$t('Dodano')), 1)
                  ]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "w-full app-button-addon absolute",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addItem(true)))
                  }, _toDisplayString(_ctx.$t('Dodaj')), 1))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}